import { makeStyles } from "@material-ui/core";
import TextField, { TextFieldProps } from "@material-ui/core/TextField";
import clsx from "clsx";
import React from "react";
import { useController, UseControllerProps } from "react-hook-form";
interface Props
  extends Omit<TextFieldProps, "onChange" | "onBlur" | "onFocus" | "name">,
    UseControllerProps<any> {
  small?: boolean;
  name: string;
}

const useStyles = makeStyles(() => ({
  small: {
    width: 100,
  },
}));

const FormInput: React.FC<Props> = ({
  name,
  size,
  className,
  control,
  rules,
  defaultValue,
  ...rest
}) => {
  const classes = useStyles();
  const {
    field: { ref, ...inputProps },
    fieldState: { invalid, isTouched, error },
  } = useController({
    name,
    control,
    rules,
    defaultValue,
  });
  const hasError = !!error && isTouched && invalid;
  const errorText = error ? error.message : "";
  return (
    <TextField
      {...rest}
      {...inputProps}
      inputRef={ref}
      helperText={errorText}
      error={hasError}
      size={size}
      className={clsx(className, {
        [classes.small]: size === "small",
      })}
    />
  );
};

export default FormInput;
